import { useDataChange } from 'Simple/Data.js'
import { normalizePath, useSetFlowTo } from 'Simple/Flow'

export function useOnClick(props) {
  let setFlowTo = useSetFlowTo(props.viewPath)
  let change = useDataChange({
    context: 'tab',
    viewPath: props.viewPath,
  })

  return function onClick() {
    change(next => {
      next.selected.board_id = 'new'
      next.selected.has_changes = false
      next.selected.board_submenu_tab_id = 'Settings'
    })
    // default screen for a new board
    setFlowTo(
      normalizePath(props.viewPath, `../Content/Board/Content/Main/Settings`)
    )
  }
}

// The first parameter received is the event from onClick, and the second parameter is the entire data value. See /Simple/Data.js#useDataChange
export function not(_, value) {
  return !value.sidebar_toggles.is_tasks_sidebar_open
}
